import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../../API/axiosNeatex';
import type { AssetsAssignationModels } from './assetsAssignationModels';
import type { APIResponse } from '../../../Shared/shared';

export const addAssetsAssignation = createAsyncThunk(
  'AssetsAssignation/addAssetsAssignation',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>('FA/AddAssetsAssignation', item);
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


export const updateAssetsAssignation = createAsyncThunk(
  'AssetsAssignation/updateAssetsAssignation',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>('FA/UpdatAssetsAssignation', item);
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAssetsAssignationList = createAsyncThunk(
  'AssetsAssignation/getAssetsAssignationList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<AssetsAssignationModels[]>>('FA/GetAssetsAssignationList');
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAssetsAssignationById = createAsyncThunk(
  'AssetsAssignation/getAssetsAssignationById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<AssetsAssignationModels>>(`FA/GetAssetsAssignationById?Id=${id}`);
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);



export const getAssetsAssignationByFaAssetsId = createAsyncThunk(
  'AssetsAssignation/getAssetsAssignationByFaAssetsId',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<AssetsAssignationModels>>(`FA/GetAssetsAssignationByFaAssetsId?ModelId=${id}`);
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  AssetsAssignationList: AssetsAssignationModels[];
  AssetsAssignationById: AssetsAssignationModels;
  AssetsAssignationByFaAssetsId: AssetsAssignationModels;
  loading: boolean;
  error: any | null;
} = {
  AssetsAssignationList: [],
  AssetsAssignationById: {} as AssetsAssignationModels,
  AssetsAssignationByFaAssetsId: {} as AssetsAssignationModels,
  loading: false,
  error: null,
};

const AssetsAssignationSlice = createSlice({
  name: 'AssetsAssignation',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
 

      .addCase(getAssetsAssignationList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAssetsAssignationList.fulfilled, (state, action: PayloadAction<AssetsAssignationModels[]>) => {
        state.loading = false;
        state.AssetsAssignationList = action.payload;
      })
      .addCase(getAssetsAssignationList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
 

      .addCase(getAssetsAssignationById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAssetsAssignationById.fulfilled, (state, action: PayloadAction<AssetsAssignationModels>) => {
        state.loading = false;
        state.AssetsAssignationById = action.payload;
      })
      .addCase(getAssetsAssignationById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
 

      .addCase(getAssetsAssignationByFaAssetsId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAssetsAssignationByFaAssetsId.fulfilled, (state, action: PayloadAction<AssetsAssignationModels>) => {
        state.loading = false;
        state.AssetsAssignationByFaAssetsId = action.payload;
      })
      .addCase(getAssetsAssignationByFaAssetsId.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default AssetsAssignationSlice.reducer;
